import type { SectionProps } from "../types";

const commitments = [
  {
    icon: "ri-close-circle-line",
    title: "Không Dạy Lan Man",
    description:
      "Mỗi bài học đều có mục tiêu rõ ràng, tập trung vào những gì thực sự quan trọng và cần thiết.",
  },
  {
    icon: "ri-close-circle-line",
    title: "Không Xa Rời Thực Tế",
    description:
      "Mọi kiến thức đều gắn liền với ứng dụng thực tế và nhu cầu của thị trường lao động.",
  },
  {
    icon: "ri-check-double-line",
    title: "Học Để Làm Được Việc",
    description:
      "Mục tiêu cuối cùng là bạn có thể tự tin làm việc trong môi trường công nghệ chuyên nghiệp.",
  },
];

export default function CommitmentSection({
  isVisible,
  sectionRef,
}: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="commitment"
      className="py-16 sm:py-20 md:py-24 lg:py-32 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-6 sm:mb-8 px-4">
            Cam Kết & Triết Lý Đào Tạo
          </h2>

          <div className="space-y-4 sm:space-y-5 md:space-y-6 text-left max-w-3xl mx-auto">
            {commitments.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-3 sm:gap-4 bg-gray-50 rounded-xl p-4 sm:p-5 md:p-6"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-cyan-500 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-xl sm:text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-[#2a4b7c] mb-1.5 sm:mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

